export default __webpack_public_path__ + "static/media/gallery-button-left.d079683d.svg";